import type { InfoPageContent } from './infoTypes';
import { aboutContent } from './about';
import { disclaimerContent } from './disclaimer';
import { guidesContent } from './guides';
import { howItWorksContent } from './howItWorks';
import { privacyContent } from './privacy';
import { termsContent } from './terms';

/** Canonical list of static documentation/legal pages. */
export const INFO_PAGES = ['how-it-works', 'guides', 'about', 'disclaimer', 'terms', 'privacy'] as const;
export type InfoPageId = (typeof INFO_PAGES)[number];

export const INFO_PAGE_CONTENT: Record<InfoPageId, InfoPageContent> = {
  'how-it-works': howItWorksContent,
  guides: guidesContent,
  about: aboutContent,
  disclaimer: disclaimerContent,
  terms: termsContent,
  privacy: privacyContent,
};
